import React from 'react';
import ReactDOM from "react-dom";
import ProjetListFieldsComponent from './components/_projetListFieldsComponent.jsx';

const fieldsListVal = document.getElementById('frm_projet_champs');
function updateFields(value) {
	fieldsListVal.value = JSON.stringify(value);
}
window.updateFields = updateFields;


const frm = document.getElementById('frm_projet');
if (frm) {

	const toggle_children = document.getElementById('frm_projet_has_children');
	const childrenField = document.getElementById('frm_projet_children');
	const formChild = document.getElementById('frm_child');
	const childrenList = document.getElementById('children-list');

	function parseChildrenField() {
		if (childrenField.value == '')
			return;
		let json = JSON.parse(childrenField.value);
		if (!json)
			return;

		for (var i = 0; i < json.length; i++) {
			let id = json[i].id != '' ? json[i].id : uniqid('field');

			let clone = formChild.cloneNode(true);
			clone.id = '';
			clone.dataset.id = id;
			clone.querySelectorAll('._element').forEach(function(element) {
				let field_id = uniqid('field');
				element.innerHTML = element.innerHTML.replace(/{{id}}/g, field_id);
			});

			if (json[i].active)
				clone.querySelector('[data-name="active"]').checked = true;

			clone.querySelector('[data-name="nom"]').value = json[i].nom;

			clone.querySelector('[data-name="url"]').value = json[i].url;

			clone.querySelector('[data-name="sendinblue_api_key"]').value = json[i].sendinblue_api_key;

			clone.querySelector('[data-name="sender_email"]').value = json[i].sender_email;

			clone.querySelector('[data-name="sender_name"]').value = json[i].sender_name;

			clone.querySelector('[data-name="sender_replyto"]').value = json[i].sender_replyto;

			if (!json[i].send_email_confirmation) {
				clone.querySelector('[data-name="send_email_confirmation"]').checked = false;
				clone.querySelector('.collapse').classList.remove('show');
			}

			clone.querySelector('[data-name="send_email_confirmation"]').dataset.bsTarget += id;
			clone.querySelector('.collapse').id += id;

			clone.querySelector('[data-name="email_confirmation_objet"]').value = json[i].email_confirmation_objet;

			if (json[i].users.length) {
				clone.querySelectorAll('._user_select').forEach(function(input){
					const list = input.closest('._element').querySelector('._users_list');
					let list_users = [];
					let list_usernames = {};
					clone.querySelectorAll('#' + input.getAttribute('list') + ' option').forEach(function(option) {
						list_users.push(option.dataset.id);
						list_usernames[option.dataset.id] = option.value;
					});
					for (var j = 0; j < json[i].users.length; j++) {
						if (list_users.indexOf(json[i].users[j]) > -1) {
							let el = document.createElement('span');
							el.classList.add('d-inline-block', 'bg-primary', 'text-white', 'me-2', 'mb-2', 'px-2', 'py-1', 'rounded');
							el.innerHTML = '<input type="hidden" data-name="users" value="' + json[i].users[j] + '">' + list_usernames[json[i].users[j]] + '<a class="_delete text-white ms-2 text-decoration-none" href="javascript:;">&times;</a>';
							list.append(el);
						}
					}
				});
			}

			if (json[i].hasOwnProperty('errors')) {
				for (const field of ['nom', 'url']) {
					if (json[i].errors.hasOwnProperty(field)) {
						clone.querySelector('[data-name="' + field + '"]').classList.add('is-invalid');
						clone.querySelector('[data-name="' + field + '"]').nextElementSibling.textContent = json[i].errors[field];
					}
				}
			}

			clone.querySelectorAll('input').forEach(function(input) {
				if (input.type == 'checkbox')
					input.addEventListener('change', updateChildrenField);
				else
					input.addEventListener('input', updateChildrenField);
			});

			clone.querySelector('.btn-close').addEventListener('click', deletePane);

			clone.querySelectorAll('._user_select').forEach(function(input) {
				input.addEventListener('change', addUserList);
			});
			clone.querySelectorAll('._delete').forEach(function(deleteLink) {
				deleteLink.addEventListener('click', deleteUserList);
			});

			clone.querySelectorAll('._copy_clipboard').forEach(function(btn) {
				btn.addEventListener('click', copyUrlToClipboard);
			});

			childrenList.append(clone);
		}
	}

	document.getElementById('zone_children').querySelector('._add_tab').addEventListener('click', function(event) {
		event.preventDefault();
		let id = uniqid('field');

		let clone = formChild.cloneNode(true);
		clone.removeAttribute('id');
		clone.dataset.id = '';
		clone.querySelectorAll('._element').forEach(function(element) {
			let field_id = uniqid('field');
			element.innerHTML = element.innerHTML.replace(/{{id}}/g, field_id);
		});

		clone.querySelector('[data-name="send_email_confirmation"]').dataset.bsTarget += id;
		clone.querySelector('.collapse').id += id;

		clone.querySelectorAll('input').forEach(function(input) {
			if (input.type == 'checkbox')
				input.addEventListener('change', updateChildrenField);
			else
				input.addEventListener('input', updateChildrenField);
		});

		clone.querySelectorAll('._user_select').forEach(function(input) {
			input.addEventListener('change', addUserList);
		});

		clone.querySelector('.btn-close').addEventListener('click', deletePane);

		clone.querySelectorAll('._copy_clipboard').forEach(function(btn) {
			btn.addEventListener('click', copyUrlToClipboard);
		});

		childrenList.append(clone);
	});

	const updateChildrenField = function() {
		let json = [];
		childrenList.querySelectorAll('._child').forEach(function(pane) {
			let child = {};
			child.id = pane.dataset.id !== undefined ? pane.dataset.id : '';
			child.active = pane.querySelector('[data-name="active"]').checked;
			child.nom = pane.querySelector('[data-name="nom"]').value;
			child.url = pane.querySelector('[data-name="url"]').value;
			child.sendinblue_api_key = pane.querySelector('[data-name="sendinblue_api_key"]').value;
			child.sender_email = pane.querySelector('[data-name="sender_email"]').value;
			child.sender_name = pane.querySelector('[data-name="sender_name"]').value;
			child.sender_replyto = pane.querySelector('[data-name="sender_replyto"]').value;
			child.send_email_confirmation = pane.querySelector('[data-name="send_email_confirmation"]').checked;
			child.email_confirmation_objet = pane.querySelector('[data-name="email_confirmation_objet"]').value;
			child.users = [];
			pane.querySelectorAll('[data-name="users"]').forEach(function(input) {
				child.users.push(input.value);
			});
			json.push(child);
		});
		childrenField.value = JSON.stringify(json);
	};

	const deletePane = function(event) {
		event.preventDefault();
		let msg = event.target.dataset.confirm === undefined || event.target.dataset.confirm == '' ? 'Voulez-vous supprimer cet élément ?' : event.target.dataset.confirm;
		if (window.confirm(msg)) {
			event.target.closest('._child').remove();
			updateChildrenField();
		}
	}

	const addUserList = function(event) {
		const input = event.target;
		const list = input.closest('._element').querySelector('._users_list');
		let users = [];
		list.querySelectorAll('input').forEach(function(input) {
			users.push(input.value);
		});
		const mainList = input.closest('#zone_users');
		document.querySelectorAll('#' + input.getAttribute('list') + ' option').forEach(function(option) {
			if (option.value == input.value && users.indexOf(option.dataset.id) == -1) {
				let el = document.createElement('span');
				el.classList.add('d-inline-block', 'bg-primary', 'text-white', 'me-2', 'mb-2', 'px-2', 'py-1', 'rounded');
				el.innerHTML = '<input type="hidden" ' + ( mainList ? 'name="users[]"' : 'data-name="users"' ) + ' value="' + option.dataset.id + '">' + option.value + '<a class="_delete text-white ms-2 text-decoration-none" href="javascript:;">&times;</a>';
				list.append(el);
				input.value = '';
				el.querySelector('._delete').addEventListener('click', deleteUserList);
				if (!mainList)
					updateChildrenField();
			}
		});
	}

	const deleteUserList = function(event) {
		event.preventDefault();
		let parent = event.target.closest('span');
		const mainList = parent.closest('#zone_users');
		parent.remove();
		if (!mainList)
			updateChildrenField();
	}

	const copyUrlToClipboard = function(event) {
		event.preventDefault();
		const parent = event.target.closest('.input-group');
		const input = parent.querySelector('input');
		let oldUrl = input.value;
		input.value = parent.querySelector('.input-group-text').textContent + oldUrl;
		input.select();
		document.execCommand("copy");
		input.value = oldUrl;
		input.blur();
		addToast('primary', 'L\'url a été copiée dans le presse-papier.')
	}

	docready(function() {
		let zoneSingleCollapse = new bootstrap.Collapse(document.getElementById('zone_single'), {
			toggle: false
		});
		let zoneChildrenCollapse = new bootstrap.Collapse(document.getElementById('zone_children'), {
			toggle: false
		});
		let zoneUsersCollapse = new bootstrap.Collapse(document.getElementById('zone_users'), {
			toggle: false
		});
		let zoneEmailConfirmationCollapse = new bootstrap.Collapse(document.getElementById('zone_confirmation_objet'), {
			toggle: false
		});
		toggle_children.addEventListener('change', function() {
			if (toggle_children.checked) {
				zoneChildrenCollapse.show();
				zoneUsersCollapse.hide();
				zoneSingleCollapse.hide();
				zoneEmailConfirmationCollapse.hide();
				document.querySelectorAll('._disabled').forEach(function(input) {
					input.disabled = true;
				});
				document.getElementById('zone_children').querySelectorAll('._required').forEach(function(input) {
					input.required = true;
				});
			} else {
				zoneChildrenCollapse.hide();
				zoneUsersCollapse.show();
				zoneSingleCollapse.show();
				if ( document.getElementById('frm_projet_send_email_confirmation').checked )
					zoneEmailConfirmationCollapse.show();
				document.querySelectorAll('._disabled').forEach(function(input) {
					input.disabled = false;
				});
				document.getElementById('zone_children').querySelectorAll('._required').forEach(function(input) {
					input.required = false;
				});
			}
		});

		document.querySelectorAll('._user_select').forEach(function(input) {
			input.addEventListener('change', addUserList);
		});
		document.querySelectorAll('._delete').forEach(function(deleteLink) {
			deleteLink.addEventListener('click', deleteUserList);
		});

		document.querySelectorAll('._copy_clipboard').forEach(function(btn) {
			btn.addEventListener('click', copyUrlToClipboard);
		});

		parseChildrenField();
	});

	// champs additionnels
	const fieldsData = fieldsListVal.value != '' ? JSON.parse(fieldsListVal.value) : [];

	docready(function() {
		ReactDOM.render(<ProjetListFieldsComponent value={fieldsData} />, document.getElementById("frm_projet_champs_list"));
	});

}